var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import PlayIcon from '@/shared/assets/icons/play-button.svg';
import s from './feedback.module.scss';
export var Feedback = function (props) {
    if (props.variant === 'video') {
        return _jsx(VideoFeedback, __assign({}, props));
    }
    return _jsx(TextFeedback, __assign({}, props));
};
var TextFeedback = function (_a) {
    var name = _a.name, description = _a.description, text = _a.text;
    var limitedText = text.length > 400 ? "".concat(text.slice(0, 400).trimEnd(), "...") : text;
    return (_jsxs("article", { className: "".concat(s.feedback, " ").concat(s.feedback_text), children: [_jsxs("header", { className: s.feedback__header, children: [_jsx("h3", { className: s.feedback__name, children: name }), _jsx("p", { className: s.feedback__description, children: description })] }), _jsx("p", { className: s.feedback__text, children: limitedText })] }));
};
var VideoFeedback = function (_a) {
    var name = _a.name, description = _a.description, poster = _a.poster, videoSrc = _a.videoSrc;
    var _b = useState(false), isPlaying = _b[0], setIsPlaying = _b[1];
    var videoRef = useRef(null);
    var _c = name.split(' '), firstNameLine = _c[0], restNameParts = _c.slice(1);
    var secondNameLine = restNameParts.join(' ');
    var handleTogglePlay = function () {
        if (!videoRef.current)
            return;
        if (videoRef.current.paused) {
            void videoRef.current.play();
        }
        else {
            videoRef.current.pause();
        }
    };
    return (_jsx("article", { className: "".concat(s.feedback, " ").concat(s.feedback_video), children: _jsxs("div", { className: s.feedback__media, children: [_jsx("video", { ref: videoRef, className: s.feedback__video, src: videoSrc, poster: poster || undefined, onPlay: function () { return setIsPlaying(true); }, onPause: function () { return setIsPlaying(false); } }), poster ? (_jsx("img", { src: poster, alt: name, className: s.feedback__poster, style: { opacity: isPlaying ? 0 : 1 } })) : null, _jsx("button", { type: "button", className: s.feedback__overlayButton, onClick: handleTogglePlay, children: !isPlaying ? (_jsxs(_Fragment, { children: [_jsx("span", { className: s.feedback__playButton, "aria-hidden": "true", children: _jsx(PlayIcon, {}) }), _jsxs("div", { className: s.feedback__badge, children: [_jsxs("div", { className: s.feedback__badgeName, children: [firstNameLine, secondNameLine && (_jsxs(_Fragment, { children: [_jsx("br", {}), secondNameLine] }))] }), _jsx("div", { className: s.feedback__badgeDescription, children: description })] })] })) : (_jsx("span", { className: s.feedback__pause, "aria-hidden": "true", children: _jsxs("span", { className: s.feedback__pauseIcon, children: [_jsx("span", { className: s.feedback__pauseBar }), _jsx("span", { className: s.feedback__pauseBar })] }) })) })] }) }));
};
